export default "__VITE_ASSET__D5X$zxld__"